<template>
  <v-card class="pa-4 px-6" flat>
    <v-dialog v-model="dialog" max-width="500px">
      <ConfirmModal
          textMessage="Você confirma o envio da noificação?"
          cancelBtn="Cancelar"
          okbtn="Confirmar"
          @close="dialog = false"
          @action="notify()"
      />
    </v-dialog>

    <v-dialog v-model="dialogSendForResale"  max-width="800px">
      <template v-slot:default="dialog">
        <v-card class="ma-0 pa-0">
          <v-toolbar color="primary" dark>
            <h3>Notificar revendas que tenha algum produto com estoque abaixo do mínimo.</h3>
          </v-toolbar>

          <section>
            <p class="ml-2 mb-0 mt-3">Selecione as revendas</p>
            <v-select
                :rules="[(v) => v.length != 0 || 'Campo obrigatório']"
                return-object
                outlined
                :search-input.sync="searchCategoryInput"
                v-model="resaleSelected"
                append-icon="mdi-chevron-down"
                placeholder="Selecionar"
                hide-details
                clearable
                color="white"
                background-color="normalred"
                dark
                class="mx-2"
                :items="resales"
                item-text="name"
                item-value="id"
                multiple
            >
              <template v-slot:prepend-item>
                <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggleResale"
                >
                  <v-list-item-action>
                    <v-icon color="primary">
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar todas as revendas
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="removeResale(item)"
                >
                  <strong>{{ item.name }}</strong>
                </v-chip>
              </template>
            </v-select>
          </section>

          <v-card-actions class="mt-16">
            <v-row cols="12" class="d-flex align-center justify-space-between">
              <v-col cols="6">
                <v-btn
                    outlined
                    width="100%"
                    class="header-button align-items-center pl-0"
                    color="normalred"
                    elevation="0"
                    @click="dialog.value = false"
                >
                  Cancelar
                </v-btn>
              </v-col>

              <v-col cols="6">
                <v-btn
                    :disabled="resaleSelected.length <= 0"
                    width="100%"
                    class="header-button align-items-center pl-0"
                    color="normalred"
                    elevation="0"
                    @click="notifyResales()"
                >
                  Notificar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog v-model="dialogSendForProduct"  max-width="800px">
      <template v-slot:default="dialog">
        <v-card class="ma-0 pa-0">
          <v-toolbar color="primary" dark>
            <h3>Notificar revendas que tenha os produto selecionado com estoque abaixo do mínimo.</h3>
          </v-toolbar>

          <section>
            <p class="ml-2 mb-0 mt-3">Selecione os produtos</p>
            <v-select
                :rules="[(v) => v.length != 0 || 'Campo obrigatório']"
                return-object
                outlined
                :search-input.sync="searchCategoryInput"
                v-model="productsSelected"
                append-icon="mdi-chevron-down"
                placeholder="Selecionar"
                hide-details
                clearable
                color="white"
                background-color="normalred"
                dark
                class="mx-2"
                :items="products"
                item-text="product.productName"
                item-value="id"
                multiple
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="removeProduct(item)"
                >
                  <strong>{{ item.product.productName }} - {{ item.attributes.map(x => x.name).join(', ') }}</strong>
                </v-chip>
              </template>

              <template v-slot:prepend-item>
                <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggleProduct"
                >
                  <v-list-item-action>
                    <v-icon color="primary">
                      {{ iconProduct }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar todos os produtos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

              <template v-slot:item="{ active, item, attrs, on }">
                <v-list-item class="pl-5" v-on="on" v-bind="attrs" #default="{ active }">
                  <v-list-item-action >
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="pl-5">
                      <v-row no-gutters align="center">
                        Produto: {{ item.product.productName }} -
                        Atributos: {{ item.attributes.map(x => x.name).join(', ') }}
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </section>

          <v-card-actions class="mt-16">
            <v-row cols="12" class="d-flex align-center justify-space-between">
              <v-col cols="6">
                <v-btn
                    outlined
                    width="100%"
                    class="header-button align-items-center pl-0"
                    color="normalred"
                    elevation="0"
                    @click="dialog.value = false"
                >
                  Cancelar
                </v-btn>
              </v-col>

              <v-col cols="6">
                <v-btn
                    :disabled="productsSelected.length <= 0"
                    width="100%"
                    class="header-button align-items-center pl-0"
                    color="normalred"
                    elevation="0"
                    @click="notifyResales()"
                >
                  Notificar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <div class="d-flex align-center">
      <v-row cols="12" align="center" class="px-2">
        <v-col cols="6">
          <h3>Estoque mínimo das revendas</h3>
        </v-col>

        <v-col cols="6">
          <section class="d-flex justify-end">
            <v-btn
                class="header-button align-items-center pl-0"
                color="normalred"
                elevation="0"
                @click="modalSendForResale(resale)"
            >
              Notificar por revenda
            </v-btn>

            <v-btn
                class="header-button align-items-center pl-0"
                color="normalred"
                elevation="0"
                @click="modalSendForResale(product)"
            >
              Notificar por produto
            </v-btn>
          </section>
        </v-col>
      </v-row>

      <!--<v-spacer></v-spacer>
      <v-btn icon @click="excel">
        <v-icon>mdi-download</v-icon>
      </v-btn>-->
    </div>

    <v-divider class="ma-2"></v-divider>

    <v-data-table
        :items="items"
        :loading="loading"
        :headers="headers"
        class="content-table"
        style="cursor: pointer"
        hide-default-footer
        loading-text="Buscando..."
        no-data-text="Sem registros"
    >
      <template v-slot:[`item.productSku`]="{ item }">
        Produto: {{ item.productSku.product.productName }} -
        Atributos: {{ item.productSku.attributes.map(x => x.name).join(', ') }}
      </template>

      <template
          v-slot:[`item.actions`]="{ item }"
          cols="12"
          md="6"
          xs="12"
          sm="12"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                outlined
                fab
                tile
                :disabled="item.done"
                small
                class="edit-button"
                @click="showDoneModal(item, $event)"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon color="#e30011" dark>mdi-email-arrow-right-outline</v-icon>
            </v-btn>
          </template>
          <span>Notificar revenda via e-mail</span>
        </v-tooltip>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="pageCount"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import ConfirmModal from "../../components/ConfirmModal";
import Vue from "vue";
import Utils from "../../../../Utils/FormatDate";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "MinimumStock",
  components: {
    Pagination,
    ConfirmModal
  },
  props: {
    filter: Object,
  },

  async created() {
    await this.list();
    await this.listResalesStockBelowMinimumAsync();
    await this.listProductsSkuStockBelowMinimumAsync();
  },

  data() {
    return {
      pageCount: 1,
      resaleproductsku: null,
      items: [],
      resales: [],
      products: [],
      resaleSelected: [],
      productsSelected: [],
      loading: false,
      dialogSendForResale: false,
      dialogSendForProduct: false,
      searchCategoryInput: '',
      dialog: false,
      apiService: new ApiService(),
      headers: [
        {
          text: "Revenda",
          align: "center",
          sortable: false,
          value: "resale.nameFantasy",
        },
        {
          text: "Sku",
          align: "center",
          sortable: false,
          value: "productSku",
        },
        {
          text: "Quantidade em estoque",
          align: "center",
          sortable: false,
          value: "quantity",
        },
        {
          text: "Estoque minimo",
          align: "center",
          sortable: false,
          value: "productSku.minimumStock",
        },
        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      pageSize: 10,
      currentPage: 10,
      totalItems: 10,
      page: 1,
      resale: 1,
      product: 2,
      minimumStockcs: {
        resaleIds: [],
        productSkuIds: [],
        notifyBy: 1
      },
    };
  },
  computed: {
    likesAllResaleSelected () {
      return this.resaleSelected.length === this.resales.length
    },
    likesSomeResaleSelected () {
      return this.resaleSelected.length > 0 && !this.likesAllResaleSelected
    },
    likesAllProductSelected () {
      return this.productsSelected.length === this.products.length
    },
    likesSomeProductSelected () {
      return this.productsSelected.length > 0 && !this.likesAllProductSelected
    },
    icon () {
      if (this.likesAllResaleSelected) return 'mdi-close-box'
      if (this.likesSomeResaleSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    iconProduct () {
      if (this.likesAllProductSelected) return 'mdi-close-box'
      if (this.likesSomeProductSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },
    async list() {
      try {
        this.loading = true;
        this.apiService
            .post(
                "dashboard/minimum-stock",
                {...this.filter, page: this.page},
                false,
            )
            .then((response) => {
              this.items = response.content.data;
              this.pageCount = response.content.pager.totalPages;
              this.totalItems = response.content.pager.totalItems;
              this.currentPage = response.content.pager.currentPage;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
      } catch (e) {
      }
    },

    async backPage() {
      this.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.page += 1;
      await this.list();
    },

    async removeResale(item) {
      const index = this.resaleSelected.findIndex((x) => x.id === item.id)
      this.resaleSelected.splice(index, 1)
    },

    async removeProduct(item) {
      const index = this.resaleSelected.findIndex((x) => x.id === item.id)
      this.productsSelected.splice(index, 1)
    },

    async listResalesStockBelowMinimumAsync() {
      try {
        this.loading = true;

        this.apiService
            .post(
                "dashboard/stock-below-minimum",
                {...this.filter, page: this.page},
                false,
                false,
                false
            )
            .then((response) => {
              const {content} = response
              this.resales = content;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
      } catch (e) {
      }
    },

    async listProductsSkuStockBelowMinimumAsync() {
      try {
        this.loading = true;

        this.apiService
            .post("dashboard/products-stock-below-minimum",{...this.filter, page: this.page},
                false,
                false,
                false
            )
            .then((response) => {
              const {content} = response
              this.products = content;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
      } catch (e) {
      }
    },

    toggleResale () {
      this.$nextTick(() => {
        if (this.likesAllResaleSelected) {
          this.resaleSelected = []
        } else {
          this.resaleSelected = this.resales.slice()
        }
      })
    },

    toggleProduct () {
      this.$nextTick(() => {
        if (this.likesAllProductSelected) {
          this.productsSelected = []
        } else {
          this.productsSelected = this.products.slice()
        }
      })
    },

    modalSendForResale(notifyBy){
      if(notifyBy === this.resale){
        this.dialogSendForResale = true
        this.minimumStockcs.notifyBy = this.resale
      } else {
        this.dialogSendForProduct = true
        this.minimumStockcs.notifyBy = this.product
      }
    },

    excel() {
      this.loading = true;

      this.apiService
          .post(
              "dashexport/reimbursement",
              false,
              false,
              false,
              true
          )
          .then((response) => {
            const excel =
                "data:application/octet-stream;base64," + response.content;
            const link = document.createElement("a");
            link.href = excel;
            link.setAttribute("download", `reembolsos.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    showDoneModal(item, event) {
      event.stopPropagation();
      this.resaleproductsku = item
      this.dialog = true
    },

    notify() {
      try {
        this.dialog = false
        this.apiService.post("resaleproductsku/notify-resale", this.resaleproductsku, false, false, true)
            .then((response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: response.message ? response.message : "Revenda notificada",
                trace: null,
              });
              this.list()
            })
            .catch(() => {
              this.loading = false;
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível notificar revenda",
                trace: null,
              });
            });
      } catch (e) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Não foi possível marcar o pedido de reembolso como concluído.",
          trace: null,
        });
      }
    },

    notifyResales() {
      try {
        if(this.minimumStockcs.notifyBy === this.resale){
          this.minimumStockcs.resaleIds = this.resaleSelected.map((x) => x.id)
        } else {
          this.minimumStockcs.productSkuIds = this.productsSelected.map((x) => x.id)
        }
        this.dialogSendForResale = false
        this.dialogSendForProduct = false
        this.apiService.post("resaleproductsku/notify-resales", this.minimumStockcs, false, false, true)
            .then((response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: response.message ? response.message : "Revendas notificadas",
                trace: null,
              });
              this.list()
            })
            .catch((error) => {
              this.loading = false;
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível notificar revendas",
                trace: null,
              });
            });
      } catch (e) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Não foi possível marcar o pedido de reembolso como concluído.",
          trace: null,
        });
      }
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.list();
      },
    },
  },
};
</script>

<style>
.done {
  color: #FFFFFF;
  padding: 5px;
  border-radius: 3px;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
  background: #8dc63f !important;
}

.not_done {
  margin-top: 10px;
  color: #FFFFFF;
  padding: 5px;
  border-radius: 3px;
  font-weight: bold;
  text-align: center;
  background: #e30011 !important;
}

.edit-button {
  margin-top: -5px !important;
  border: 1px solid #e30011 !important;
  border-radius: 4px;
  width: 35px !important;
  height: 30px !important;
}
</style>
